// extracted by mini-css-extract-plugin
module.exports = {"chart":"Statistics_chart__1rM47","smallChart":"Statistics_smallChart__3NM1y"};